<template>
  <div class="tab-switch">
    <div
      v-for="tab in tabs"
      :key="tab.value"
      :class="['tab-btn', { active: props.modelValue === tab.value }]"
      @click="emit('update:modelValue', tab.value)"
    >
      {{ tab.label }}
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue'

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
    default: () => []
  },
  modelValue: {
    type: [String, Number],
    required: true
  }
})

const emit = defineEmits(['update:modelValue'])

const activeTab = ref(props.modelValue)

// 监听props变化，更新内部值
watch(
  () => props.modelValue,
  newValue => {
    activeTab.value = newValue
  }
)

// 监听内部变化，更新父组件
watch(activeTab, newValue => {
  emit('update:modelValue', newValue)
  emit('change', newValue)
})
</script>

<style lang="scss" scoped>
.tab-switch {
  display: inline-flex;
  border-radius: 4px;
  background: #f0f2f5;
  overflow: hidden;
  color: #595959;
  font-size: 14px;

  .tab-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: none;
    color: #333;
    cursor: pointer;
    outline: none;
    transition: all 0.2s;
    width: 80px;
    height: 100%;
    padding: 8px 0;
    &.active {
      background: #1677ff;
      color: #fff;
    }
  }
}
</style>
